import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { UserPreferencesUnsubscribeBaseCtrl } from './UserPreferencesUnsubscribeBaseCtrl';

export function UserPreferencesUnsubscribeAnonRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.UserPreferencesUnsubscribeAnon', {
		url: '/preferences/unsubscribe/anon',
		controllerAs: 'vm',
		controller: UserPreferencesUnsubscribeAnonCtrl,
		templateUrl: '/ng/hub/User/Preferences/Unsubscribe/UserPreferencesUnsubscribeCtrl.html?' + window.BUILD,
		resolve: {
			style: () => AssetManager.css('/ng/hub/User/Preferences/Unsubscribe/UserPreferencesUnsubscribeCtrl.css'),
			$title: () => 'Unsubscribe',
		},
	});
}

export class UserPreferencesUnsubscribeAnonCtrl extends UserPreferencesUnsubscribeBaseCtrl {
	getName() {
		return 'UserPreferencesUnsubscribeAnon';
	}

	getInactiveTables() {
		return ['actAlert'];
	}

	afterUpdateParam() {
		this.setAuthHeader();
	}

	resetData() {
		super.resetData();
		this.clickHash = '';
	}

	setAuthHeader() {
		if (this.error) {
			return false;
		}

		// If this is a non-logged-in user, redirect to the unsubscribed success page. (Because there are no additional
		// unsubscribe step necessary - or possible - without having a fully logged-in user.)
		if (this.ref === 'me' && !this.Identity.isLoggedin()) {
			window.location.href = `${window.BASE_URL}/core/unsubscribed`;
			return;
		}

		let endpoint = '/v2/users/unsubscribe/click_hash' + this.getFormattedParams();

		this.Api.request('GET', endpoint, null, { Authorization: 'Public' }).then(resp => {
			if (this._isBadResponse(resp)) {
				let msg = 'Unable to retrieve auth token';
				this.Logger.write('ERROR', msg + ': ' + (resp.statusText || 'Unknown'), {
					params_from_attempt: this.getFormattedParams(),
				});
				this.setError(msg);
				return false;
			}
			this.clickHash = resp.data.hash;
			this.reqHeaders = {
				Authorization: 'Email ' + this.clickHash,
			};
			this.loadData();
		});
	}
}
